module.exports = __webpack_public_path__ + "static/media/Time_Illustrations-01.92988bd9.svg";